import React, { Fragment } from 'react'
import classnames from 'classnames'
import { useScrollDown, useToggle, useOnScreen } from '../../utils/hooks'
import ErrorModal from '../../components/ErrorModal'
import Header from '../Header'
import Inputs from './Inputs'
import Meals from './Meals'
import Gutter from './Gutter'
import MenuCategories from './MenuCategories'
import Bag from './Bag'

import SelectedMeals from './SelectedMeals'

import './Menu.css'

const Menu = props => {
  const { getOrderSummary, history, getMenu } = props

  const [showErrorModal, toggleErrorModal] = useToggle(false)
  const [showSelectedMeals, toggleSelectedMeals] = useToggle(false)
  const isScrollingDown = useScrollDown()
  const [inputsRef, inputsOnScreen] = useOnScreen()

  const onCheckout = () => {
    getOrderSummary().then(success => {
      if (success) {
        history.push('/checkout')
      } else {
        toggleErrorModal()
      }
    })
  }

  const onTryAgain = () => {
    toggleErrorModal()
    getMenu()
  }

  return (
    <Fragment>
      <ErrorModal
        isOpen={showErrorModal}
        title="Out of stock :("
        subtitle="One or more of your selected meals are out of stock."
        onRequestClose={onTryAgain}
      />
      <SelectedMeals
        isOpen={showSelectedMeals}
        onClose={toggleSelectedMeals}
        onCheckout={onCheckout}
      />

      <main className="cookunity__menu">
        <div
          className={classnames('header_container', {
            scrollingUp: !isScrollingDown
          })}>
          <Header />
        </div>

        <section className="cookunity__menu__title">
          <div className="cookunity__wrapper">
            <h1>
              Choose and <span>enjoy</span>
            </h1>
            <p>These are the healthy & tasty options on our menu today.</p>
          </div>
        </section>

        <div
          ref={inputsRef}
          className={classnames('inputs_container', {
            scrollingUp: !isScrollingDown
          })}>
          <Inputs />
        </div>

        <div
          className={classnames('categories_wrapper', {
            scrollingDown: isScrollingDown
          })}>
          <div className="categories_container">
            <MenuCategories />
            <Bag onBagClick={toggleSelectedMeals} />
          </div>
        </div>

        <Meals />

        {!showSelectedMeals && (
          <Gutter
            toggleSelectedMeals={toggleSelectedMeals}
            className={classnames({ hidden: inputsOnScreen })}
          />
        )}
      </main>
    </Fragment>
  )
}

export default Menu



// WEBPACK FOOTER //
// ./src/modules/Menu/Menu.jsx